"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeIngestVideosClient = void 0;
const types_1 = require("../../../types");
const isNotEmpty_1 = require("./isNotEmpty");
class FakeIngestVideosClient {
    constructor() {
        this.videos = [];
    }
    insertIngestVideoFixture(video) {
        this.videos.push(video);
    }
    static applyFilters(video, filterRequest) {
        if (filterRequest && (0, isNotEmpty_1.isNotEmpty)(filterRequest.channelName)) {
            return video.channel.name === filterRequest.channelName;
        }
        else if (filterRequest && filterRequest.statuses) {
            return filterRequest.statuses.includes(video.status);
        }
        else {
            return true;
        }
    }
    getAll(page, filterRequest) {
        const videosToReturn = this.videos.filter((it) => FakeIngestVideosClient.applyFilters(it, filterRequest));
        return Promise.resolve({
            page: videosToReturn,
            pageSpec: {
                number: page.page,
                size: page.size,
                totalElements: videosToReturn.length,
                totalPages: Math.floor(videosToReturn.length / page.size),
                nextPage: new types_1.Link({
                    href: `/v1/ingest-videos?size=${page.size}&page=${page.page + 1}`,
                }),
                previousPage: new types_1.Link({
                    href: `/v1/ingest-videos?size=${page.size}&page=${page.page - 1}`,
                }),
            },
        });
    }
    clear() {
        this.videos = [];
    }
}
exports.FakeIngestVideosClient = FakeIngestVideosClient;
//# sourceMappingURL=FakeIngestVideosClient.js.map